var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    rx: 1,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9.41431 32.0415)",
    fill: "#646782"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6274,
    y: 32.0415,
    width: 32,
    height: 2,
    rx: 1,
    transform: "rotate(-135 30.6274 32.0415)",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoModalClose);
export default __webpack_public_path__ + "static/media/ico-modal-close.fac1806ec12ad070175bc166ecd6c3a3.svg";
export { ForwardRef as ReactComponent };